import React, { ButtonHTMLAttributes } from 'react';

import { COLORS } from '../../styles/constants';
import { Container } from './styles';

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  loading?: boolean;
};

const Button: React.FC<ButtonProps> = ({
  children,
  loading,
  color = COLORS.primary,
  ...rest
}) => (
  <Container type="button" color={color} {...rest}>
    {loading ? 'Carregando...' : children}
  </Container>
);

export default Button;
